import React, { Component } from 'react';
interface Product {
  name: string;
  badge: string;
  badgeColor: string;
  image: string;
  href: string;
}
const products: Product[] = [{
  name: 'M35HP',
  badge: 'Precision machine',
  badgeColor: 'bg-[#1874cd]',
  image: 'https://seibu-america.com/assets/img/product/product01.png',
  href: 'https://seibu-america.com/products/m35hp/'
}, {
  name: 'MM35UP',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product02.png',
  href: 'https://seibu-america.com/products/mm35up/'
}, {
  name: 'M50HP',
  badge: 'Precision machine',
  badgeColor: 'bg-[#1874cd]',
  image: 'https://seibu-america.com/assets/img/product/product03.png',
  href: 'https://seibu-america.com/products/m50hp/'
}, {
  name: 'MM50UP',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product04.png',
  href: 'https://seibu-america.com/products/mm50up/'
}, {
  name: 'M75B / MM75B',
  badge: 'High precision machine',
  badgeColor: 'bg-[#0D7377]',
  image: 'https://seibu-america.com/assets/img/product/product05.png',
  href: 'https://seibu-america.com/products/m75b/'
}, {
  name: 'SuperMM80B',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product06.png',
  href: 'https://seibu-america.com/products/supermm80b/'
}, {
  name: 'MEX15 (Water)',
  badge: 'Ultra-precision machine',
  badgeColor: 'bg-[#D4A843]',
  image: 'https://seibu-america.com/assets/img/product/product07.png',
  href: 'https://seibu-america.com/products/mex15/'
}];
export function WaterSpecificationSection() {
  return <section data-id="element-3676">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3677">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-3678">
          Water Specification Wire EDM
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-3679">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-3680">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-3681">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block relative" data-id="element-3682">
                <span className={`absolute top-3 left-3 ${product.badgeColor} text-white px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider shadow-sm z-10`} data-id="element-3683">
                  {product.badge}
                </span>
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-3684" />
              </a>

              <div className="p-5 flex flex-col flex-grow" data-id="element-3685">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-3686">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-3687">
                    {product.name}
                  </h3>
                </a>

                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-3688">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent('Seibu ' + product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-3689">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-3690">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}